// Una inspección 'declarada' se carga después por declaración, y la pantalla ya la rotula como
// 'Declarada (registrada después)': no se le suma la marca 'Tardío'. El dato registro_tardio
// de la base y las exportaciones CSV no cambian.
export const esTardio = (r) => !!r?.registro_tardio && r?.origen !== 'declarada';
